import BackgroundImg from "../components/BackgroundImg/BackgroundImg"
import Footer from "../components/Footer/Footer"

const Home = () => {
  return (
    <>
      <BackgroundImg />
      <Footer />
    </>
  )
}

export default Home